import GpanelContactsTrashContacts from './gpanel-contacts-trash-contacts';

export default function GpanelContactsTrashContactsPage() {
  return <GpanelContactsTrashContacts />;
}
